import { Component } from '@angular/core';

import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { NceService } from '../services/nce.service';

@Component({
    selector: 'nce-final-approval',
    templateUrl: '../../shared/components/preview/preview-parent.component.html'
})
export class NceFinalApprovalComponent{

    vCurrentAccor: number;
    vExpandStatus = [false, false, false, false, false];

    vNCEid = this._nceService.getNCEID().nce_record_id;
    
    constructor(
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _nceService: NceService
    ) { }

    ngOnInit() {
    	this._layoutService.setCurrentPage('nce-final-approval');
        this._nceService.loadDetailNCE(this._nceService.getNCEID().nce_record_id);
    }

    ngOnDestroy(){
        this._nceService.resetAllNCEData();
        this._storageService.removeSessionItem('extensionNCE');
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    getDetailNCE(){
        return this._nceService.getDetailNCE();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/final-approval.component.ts